import { isNotEmpty } from '@/lib/utils'

export default function suffix(str = '', suffix, value) {
	// console.log('suffix', value)
	if (isNotEmpty(value)) {
		return [str,suffix].join('')
	}
}
